import create, {createPost} from 'utils/command'
import {shuffleArray} from 'utils/random'

export function getAssessmentPoints(assessment) {
  const {properties: {bonus = 0}, assessmentProperties: {value}, answeredAssessmentRecord: record} = assessment
  return record
    ? Object.values(record.results).reduce((acc, {total, points}) => ({total: acc.total + total, value: acc.value + points}), {total: 0, value: bonus})
    : {total: value}
}

export function findGlobalIndex (id, sections = []) {
  let j = 0 
  for (let i = 0; i < sections.length; i++) {
    const section = sections[i]
    const index = section.questions.findIndex(q => q.id == id)
    if (index >= 0) return j + index
    j += section.questions.length
  }
  return -1
}

export function initAnswer(types, question) {
  const type = types.find(t => t.id == question.type) || {}
  const {defaultStudentAnswer = {}} = type.properties || {}

  function getDefault() {
    if (type.name == 'fill-in-the-blanks') {
      const {phrases = []} = question.answer
      return {phrases: phrases.map(p => p.blanked ? ({blanked: true, phrase: ''}) : p)}
    }
    else if (type.name == 'matching') {
      const {choices = []} = question.answer
      const terms = shuffleArray(choices.map(([term], index) => ({term, index})))
      const definitions = shuffleArray(choices.map(([_,definition], index) => ({definition, index})))
      const selected = terms.map(() => -1)
      return {terms, definitions, selected}
    }
    else if (type.name == 'multiple-choice' && question.properties.shuffle) {
      const {choices = []} = question.answer
      return {selected: null, selectedOptions: [], choices: shuffleArray(choices)}
    }
    return defaultStudentAnswer
  }

  return answer =>
    !answer
      ? {pending: false, completed: false, ...getDefault()} 
      : answer
}

export function startAssessment(id) {
  return create('quiz', 'startAssessment')({id}) 
}

export function saveAnswers(id, answers, finalize) {
  return createPost('quiz', 'saveStudentAnswers')({id, answers, finalize})
}
